<div class="row ml-2 mr-2">
  <kendo-grid [data]="view.gridData" [loading]="view.loading"
    [pageable]="count > view.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="view.state.take"
    [skip]="view.state.skip" [sortable]="true" [sort]="view.state.sort" [filterable]="currentEnableAdvanced"
    [filter]="view.state.filter" [selectable]="{ mode: 'single' }" [columnMenu]="false" [resizable]="true"
    [reorderable]="currentEnableAdvanced" (dataStateChange)="dataStateChange($event)">
    <kendo-grid-column *ngFor="let col of columnsConfig" [field]="col.field" [title]="col.title" [width]="col.width"
      [filter]="col.filter" [format]="col.format" [filterable]="col.filterable" [sortable]="col.sortable"
      [hidden]="col.hidden">
    </kendo-grid-column>
  </kendo-grid>
</div>